module.exports = __webpack_public_path__ + "static/bg-welcome-adc673cdb3deb3b136e34f49c6fcb7fc.jpg";